'use strict';

var formPrepare = require('../pages/checkout/formPrepare');
const progress = require("../progress");

function updateStoreData(init)
{
	if(window.brandStores === undefined) {
		return;
	}
	
	if(init === undefined) {
		init = false;
	}
	var brandValue = getBrandSelectorEl();
	if(!brandValue) {
	    return;
	}
	
	var storeList;
	storeList = window.brandStores[brandValue.value];
	
	if(storeList === undefined || storeList.stores === undefined) {
        if(init==true){
            var storeSelector = getStoreSelectorEl();
            $(storeSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_BRAND_FIRST + '">' + Resources.SELECT_BRAND_FIRST + '</option>');
        }
		return;
	}
	
	var storeSelector = getStoreSelectorEl();
	var lists = storeList.stores;
	$(brandValue).trigger('blur');
	if(storeSelector && lists.length > 0) {
		storeSelector = getStoreSelectorEl();
		$(storeSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_QR_STORE + '">' + Resources.SELECT_QR_STORE + '</option>');
		for(var i=0;i<lists.length;i++) {
			if(lists[i] && lists[i].trim()) {
				$(storeSelector).append('<option class="select-option" label="' + lists[i] + '">' + lists[i] + '</option>');
			}
		}
		$(storeSelector).trigger('change');
	} else {
		removeStoreSelector();
		$(storeSelector).append('<option value="" class="select-option" label="' + Resources.SELECT_BRAND_FIRST + '">' + Resources.SELECT_BRAND_FIRST + '</option>');
	}
	updateFields();
}
function updateFields()
{
	var brandSelector = getBrandSelectorEl();
	var storeSelector = getStoreSelectorEl();
	if(brandSelector) {
		$(brandSelector).trigger('blur');
		if(storeSelector) {
            $(storeSelector).trigger('blur'); 
        }
		formPrepare.validateForm();
	}
}
function removeStoreSelector(init)
{
	if(init === undefined) {
		init = false;
	}
	var storeSelector = getStoreSelectorEl();
	if(storeSelector && storeSelector.length > 0) {
		if(!$(storeSelector).hasClass('select2-option')) {
			$(storeSelector).selectric('init');
		}
		$(storeSelector).empty();
		$(storeSelector).trigger('blur');
	}
}

function getBrandSelectorEl()
{
	return document.querySelector('[id$="_storeqr_brand"]');
}

function getStoreSelectorEl()
{
	return document.querySelector('[id$="_storeqr_store"]');
}

function updateBrandStore(init)
{
	var brand = getBrandSelectorEl();
	if(!brand) {
		return;
	}
	
	if(window.brandStores !== undefined) {
		removeStoreSelector(init);
		updateStoreData(init);
		return;
	}
	
}

function afterSuccess(response, init)
{
	if(response && response.status !== undefined && response.status == true) {
		window.brandStores = response.list;
		updateBrandStore(init)
	} 
    
}

exports.init = function () {
	var brandSelector = getBrandSelectorEl();
	if(brandSelector) {
		var initBrandValue = brandSelector.value;
		var brandSelectorEl = $(brandSelector);
		
		brandSelectorEl.on('change', function(e) {
			e.stopPropagation();
			if(initBrandValue != $(this).val()) {
				updateBrandStore();
				initBrandValue = $(this).val();
			}
		});
		updateBrandStore(true);
	}
	initStoreField();
}

function initStoreField()
{
	var storeSelector = getStoreSelectorEl();
	if(storeSelector) {
		$(storeSelector).on('change', function(e) {
			e.stopPropagation();
			$(this).trigger('blur');
			formPrepare.validateForm();
		});
	}
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/storeqr.js